export default {

	init() {

		var container = document.querySelector('.inPost');

		if( container ) {

			var inPostInputValue = 'inpost';
			var shippingTable = document.querySelector('#order_review');
			
			
			var inPostMap = container.querySelector('#inPostMap');
			var objectHeight = 0;

			var interval = null;
			var map;

			var inPostFields = container.querySelector('.inPost__fields');
			var field = inPostFields.querySelector('input#ship_to_different_address');
			var fieldID = inPostFields.querySelector('input#shipping_last_name');
			var fieldInPost = inPostFields.querySelector('input#shipping_first_name');
			var fieldCity = inPostFields.querySelector('input#shipping_city');
			var fieldZipCode = inPostFields.querySelector('input#shipping_postcode');
			var fieldAddress = inPostFields.querySelector('input#shipping_address_1');
			var fieldAddressValue = '';

			fieldID.setAttribute('readonly', true);
			fieldID.setAttribute('value','');
			fieldCity.setAttribute('readonly', true);
			fieldCity.setAttribute('value', '');
			fieldZipCode.setAttribute('readonly', true);
			fieldZipCode.setAttribute('value', '');
			fieldAddress.setAttribute('readonly', true);
			fieldAddress.setAttribute('value','');

			// -- Functions -- // 

				function inPostMapHeightCalc( objects ) {

					objectHeight = 0;

					objectHeight += container.querySelector('p.inPost__title').offsetHeight + parseFloat( getComputedStyle( container.querySelector('p.inPost__title') ).marginBottom.replace('px','') );;

					if( objects.length > 0 ) {

						objectHeight += parseFloat( getComputedStyle(objects[0].parentElement).marginBottom.replace('px','') );

						objects.forEach( function( div,index ) {

							objectHeight += div.offsetHeight + parseFloat( getComputedStyle(div).marginBottom.replace('px','') );

						});

					}

					return objectHeight + 'px';

				}

				function shopMap() {

					if( container.getAttribute('data-show') == '1' ) {

						container.style.height = inPostMapHeightCalc( inPostMap.childNodes );
						field.setAttribute('value', 1);
						fieldInPost.setAttribute('value','Paczkomat');

					} else {

						field.setAttribute('value', 0);

					}

				}

				function changeShipping() {

					shippingTable.addEventListener('click', function(e) {

						if( 
							e.target.tagName == 'INPUT' && 
							e.target.classList.contains('shipping_method') && 
							e.target.closest('ul#shipping_method')
						) {

							if( e.target.value.split(':')[0] == inPostInputValue ) {

								field.setAttribute('value', 1);

								if( inPostFields.classList.contains('hide') ) {

									container.style.height = inPostMapHeightCalc( inPostMap.childNodes );

								} else {
									
									if( window.innerWidth > 540 ) {

										container.style.height = inPostMapHeightCalc( inPostFields.querySelectorAll(".inPostCalcHeight:not(.form-row-hide):not(.form-row-last)") );

									} else {

										container.style.height = inPostMapHeightCalc( inPostFields.querySelectorAll(".inPostCalcHeight:not(.form-row-hide)") );

									}

								}

							} else {

								container.style.height = '0px';

								fieldID.setAttribute('value', '');
	            				fieldCity.setAttribute('value', '');
	            				fieldZipCode.setAttribute('value', '');
	            				fieldAddress.setAttribute('value', '');
	            				field.setAttribute('value', 0);

							}

						} 

					});

				}

				function setCity() {

					var inputCityForm = document.querySelector('input#billing_city');

					inputCityForm.addEventListener('blur', function() {

						map.searchPlace(inputCityForm.value);

					});

				}

				function changeLayout( map = true ) {

					if( map == true ) { // showMap

						inPostMap.style.display = 'flex';
						inPostFields.style.display = 'none';
						inPostFields.classList.add('hide');
						container.style.height = inPostMapHeightCalc( inPostMap.childNodes );

					} else { // showFields	

						inPostMap.style.display = 'none';
						inPostFields.style.display = 'flex';
						inPostFields.classList.remove('hide');

						if( window.innerWidth > 540 ) {

							container.style.height = inPostMapHeightCalc( inPostFields.querySelectorAll(".inPostCalcHeight:not(.form-row-hide):not(.form-row-last)") );

						} else {

							container.style.height = inPostMapHeightCalc( inPostFields.querySelectorAll(".inPostCalcHeight:not(.form-row-hide)") );

						}						

					}

				}

				function resize() {

					window.addEventListener('resize', function() {

						if( !inPostFields.classList.contains('hide') ) {

							if( window.innerWidth > 540 ) {

								container.style.height = inPostMapHeightCalc( inPostFields.querySelectorAll(".inPostCalcHeight:not(.form-row-hide):not(.form-row-last)") );

							} else {

								container.style.height = inPostMapHeightCalc( inPostFields.querySelectorAll(".inPostCalcHeight:not(.form-row-hide)") );

							}

						} else {

							container.style.height = inPostMapHeightCalc( inPostMap.childNodes );

						}

					});

				}

				function resetButtons() {

					inPostMap.querySelectorAll('button').forEach( function(button, index) {

						button.setAttribute('type','button');

					});

				}

			// -- END -- //



			// -- Map init & actions -- //

				window.easyPackAsyncInit = function() {

	            	easyPack.init({
		            	mapType: 'osm',
		            	searchType: 'osm',
		            });

	            	map = easyPack.mapWidget('inPostMap', function(point) {

	            		fieldID.setAttribute('value', point.name);
	            		fieldInPost.setAttribute('value','Paczkomat');
	            		fieldCity.setAttribute('value', point.address_details.city);
	            		fieldZipCode.setAttribute('value', point.address_details.post_code);

	            		fieldAddressValue = point.address_details.street;

	            		if( point.address_details.building_number ) {

	            			fieldAddressValue += ' '+point.address_details.building_number;

	            		}

	            		if( point.address_details.flat_number ) {

	            			fieldAddressValue += ' '+point.address_details.flat_number;

	            		}

	            		fieldAddress.setAttribute('value', fieldAddressValue );

	            		changeLayout( false ); 

	            	});

	            	inPostFields.querySelector('.fields__change').addEventListener('click', function() {

	            		changeLayout();

	            		fieldID.setAttribute('value', '');
	            		fieldCity.setAttribute('value', '');
	            		fieldInPost.setAttribute('value', '');
	            		fieldZipCode.setAttribute('value', '');
	            		fieldAddress.setAttribute('value', '');


	            	});

		        };

			// -- END -- //


			interval = setInterval(
				function(){

					if( container.querySelector('#inPostMap').childNodes.length > 1 ) {

						clearInterval(interval);
						interval = null;
						resetButtons();
						shopMap();
						changeShipping();
						setCity();
						resize();

					} 

				},
				100
			);
			
		}

	},
	finalize(){

	}

}